export default {"src":"/_next/static/media/checkmark.4a59b793.svg","height":32,"width":24};